<template>
  <main id="upgrade-container" class="tw-mx-auto tw-max-w-7xl tw-px-4 sm:tw-px-6 lg:tw-px-8">
    <h1
      v-if="currentPlan"
      class="tw-m-6 tw-mx-auto tw-mt-0 tw-max-w-2xl tw-space-y-6 !tw-overflow-y-auto tw-pb-2 tw-font-sans tw-text-3xl tw-font-bold tw-text-gray-900"
    >
      Billing Details
    </h1>
    <h1
      v-else
      class="tw-m-6 tw-mx-auto tw-mt-0 tw-max-w-2xl tw-space-y-6 !tw-overflow-y-auto tw-pb-2 tw-font-sans tw-text-3xl tw-font-bold tw-text-gray-900"
    >
      Upgrade
    </h1>
    <upgrade />
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import Upgrade from '~/components/upgrade/UpgradeUser.vue';
export default {
  name: 'UpgradePage',
  components: {
    Upgrade,
  },
  layout({ $isFlagOn }) {
    return $isFlagOn('signup-flow-hide-header-footer') ? 'minimal' : 'default';
  },
  data() {
    return {
      recurlyFinishedLoading: false,
    };
  },
  head() {
    return {
      title: 'Upgrade',
    };
  },
  computed: {
    ...mapGetters(['loggedInUser', 'currentPlan']),
    isUserFree() {
      return this.loggedInUser.subscription.code === 'free';
    },
  },
  mounted() {
    if (!this.loggedInUser) {
      this.$router.push('/login');
    }
  },
};
</script>
